<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>
    <div class="ViewDieselInfo ViewPromo__section">
      <div class="ViewDieselInfo__row">
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__content">
            <h2 class="ViewDieselInfo__title">{{ name }}</h2>
            <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
            <div class="ViewDieselInfo__text app-typography">
              <p>
                <strong
                  >Основана в 2009 году, является комплексным поставщиком сырья
                  и материалов для предприятий стекольной, керамической,
                  строительной и металлургической отраслей промышленности
                  России.</strong
                >
              </p>
              <h4>Основное направление:</h4>
              <ul class="ViewDieselInfo__text-list">
                <li>
                  <img
                    src="/icons/checked.svg"
                    alt=""
                    class="ViewDieselInfo__text-list-icon"
                  />Наша компания специализируется на поставках кварцевых и
                  строительных песков, а также огнеупорных глин и каолинов по
                  всей территории Российской Федерации.
                </li>
              </ul>
              <h4>Преимущества компании:</h4>
              <p>
                Мы выполняем комплекс услуг по подбору сырья, наиболее полно
                отвечающего потребностям клиента. Вывоз и накопление сырья для
                обеспечения бесперебойности поставок в плохих погодных условиях.
                Предоставление своим клиентам отсрочки по оплате сырья и услуг
                до 45 календарных дней. Вся поставляемая продукция проходит
                лабораторный анализ и соответствует нормативным документам
                (ГОСТ, ТУ), качество подтверждается соответствующими
                сертификатами.
              </p>
            </div>
            <a
              href="https://www.youtube.com/watch?v=uxrb_qmCnOU"
              target="_blank"
              data-fancybox
              class="ViewDieselInfo__btn-video-small app-btn-video app-button-control app-button-control--secondary is-bordered"
            >
              <span class="app-button-control__content">
                <span>Смотреть видео онлайн</span>
                <app-svg-icon
                  name="youtube"
                  class="app-btn-video__icon"
                ></app-svg-icon
              ></span>
            </a>
          </div>
        </div>
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__advantages-wrapper">
            <ul class="ViewPromo__advantages">
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="iphone"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Контактные данные</h4>
                  <p>
                    Телефон компании:<br />
                    <strong
                      ><a
                        href="tel:+74959882617"
                        class="ViewPromo__advantage-contact-link"
                        >+7 (495) 988-26-17</a
                      ></strong
                    ><br />
                    <strong
                      ><a
                        href="tel:+79273561562"
                        class="ViewPromo__advantage-contact-link"
                        >+7 (927) 356-15-62</a
                      ></strong
                    >
                  </p>
                  <p>
                    Адрес электронной почты:<br />
                    <strong
                      ><a
                        href="mailto:promresurs2006@mail.ru"
                        class="ViewPromo__advantage-contact-link"
                        >promresurs2006@mail.ru</a
                      ></strong
                    ><br />
                    <strong
                      ><a
                        href="mailto:mail@metallresurs74.ru"
                        class="ViewPromo__advantage-contact-link"
                        >mail@metallresurs74.ru</a
                      ></strong
                    >
                  </p>
                  <a
                    class="ViewPromo__advantage-link"
                    href="/static/uploads/docs/Cкачать_реквизиты_пром-ресурс.doc"
                    download="Реквизиты ПромРесурс.doc"
                    >Cкачать реквизиты ПромРесурс</a
                  >
                </div>
              </li>
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="lock-pin"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                  <p>
                    <strong>Карьер в Челябинской области</strong><br />
                    (Нижне-Увельское месторождение). Челябинская обл., г.
                    Златоуст, Парковый проезд, 3 «Д».
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons
      :buttons="buttons"
      class="ViewPromo__section"
    ></view-landing-buttons>
  </div>
</template>

<script>
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.umd';

export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Пески и глины онлайн от поставщика ПромРесурс',
    desc: 'на платформе OPEN OIL MARKET',
    id: 941,
    productId: 1431,
    name: 'ООО «ПромРесурс»',
    inn: '7449060350',
    buttons: [
      {
        name: 'Купить песок',
        link: '/catalog/pesok-kvarcevyj-obogaschennyj/page/1',
      },
      {
        name: 'Купить глину',
        link: '/catalog/glina-ogneupornaya/page/1',
      },
    ],
  }),

  mounted() {
    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });
  },
  updated() {
    Fancybox.unbind(this.$refs.container);
    Fancybox.close();

    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });
  },
  unmounted() {
    Fancybox.destroy();
  },
};
</script>
